import { render, staticRenderFns } from "./PhotoGalleryModal.vue?vue&type=template&id=704e520c&scoped=true"
import script from "./PhotoGalleryModal.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoGalleryModal.vue?vue&type=style&index=0&id=704e520c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e520c",
  null
  
)

export default component.exports